//
// Filters Users by First Name, Last Name, Email and Username.
// - This uses a case insensitive compare for each field.
// - The First and Last Names are combined separated with a space to allow the Names to be
//   filtered together. For example, the filter string 'John D' will match 'John Doe' and
//   'John Deere'.
// - We first combine the fields together separated with an 'unprintable' character so that
//   we can do operations such as 'search' and 'lolower' on one field instead of multiple
//   fields to make this function operate faster.
// - This actually returns a function that can be passed to array.filter(). For example,
//        const filteredUsers = allUsers.filter(byNameEmailUsername);
//
function byNameEmailUsername(filterValue) {
  const needle = filterValue === null ? '' : filterValue.toLowerCase();
  return (user) => {
    const haystack = `${user.firstName} ${user.lastName}\t${user.email}\t${user.username}`;
    return haystack.toLowerCase().search(needle) >= 0;
  };
}

export default { byNameEmailUsername };
